import { Box, Button, Container, Typography } from '@mui/material';
import React from 'react';
import img from '../assets/home.png';

const Home = () => (
  <Box
    id="home"
    sx={{
      height: '60vh',
      backgroundSize: 'cover',
      backgroundPosition: 'center',
      backgroundRepeat: 'no-repeat',
      color: '#fff',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'left',
      textAlign: 'left',
      px: { xs: 2, sm: 4, md: 8 },
      '&::before': {
        content: '""',
        position: 'absolute',
        top: 0,
        left: 0,
        width: '100%',
        height: '60vh',
        backgroundImage: `url(${img})`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
          filter: 'brightness(50%)',
        zIndex: -1,
        
      },
    }}
  >
    <Container >
      <Typography
        variant="h3"
        sx={{
          fontWeight: 'bold',
          marginBottom: 2,
          fontSize: { xs: '1.8rem', sm: '2.5rem', md: '3rem' },
        }}
      >
        Construção com Qualidade
      </Typography>
      <Typography
        variant="h6"
        sx={{
          marginBottom: 4,
          fontSize: { xs: '1rem', sm: '1.25rem' },
        }}
      >
        Experimente o melhor em serviços de construção
        </Typography>
      <Button
        variant="contained"
        sx={{
          backgroundColor: '#1A7B30',
          color: '#fff',
          fontWeight: 'bold',
          padding: '10px 20px',
          ':hover': { backgroundColor: '#145A22' },
        }}
        href="#services"
      >
        VER SERVIÇOS
      </Button>
    </Container>
  </Box>
);

export default Home;